import { useT } from '../../i18n/index.js';
import { useSettings } from '../useSettings.js';
import { SliderRow } from './shared.js';

export function ControlsTab() {
  const t = useT();
  const scrollSpeed = useSettings((s) => s.scrollSpeed);
  const setScrollSpeed = useSettings((s) => s.setScrollSpeed);

  return (
    <div>
      <h3 className="text-sm font-medium text-foreground mb-4">{t('settings.controls.title')}</h3>
      <SliderRow
        label={t('settings.controls.scrollSpeed')}
        value={scrollSpeed}
        min={1}
        max={10}
        step={1}
        onChange={setScrollSpeed}
      />
      <div className="mt-6 space-y-2 text-xs text-muted-foreground">
        <p>
          <kbd className="px-1.5 py-0.5 rounded bg-secondary text-[11px] font-mono">Esc</kbd> —{' '}
          {t('keys.esc')}
        </p>
        <p>
          <kbd className="px-1.5 py-0.5 rounded bg-secondary text-[11px] font-mono">`</kbd> —{' '}
          {t('keys.debug')}
        </p>
        <p>
          <kbd className="px-1.5 py-0.5 rounded bg-secondary text-[11px] font-mono">Enter</kbd> —{' '}
          {t('keys.chat')}
        </p>
        <p className="text-muted-foreground/80 mt-4">{t('settings.controls.rebindSoon')}</p>
      </div>
    </div>
  );
}
